import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { WebservicesService } from "src/app/services/webservices/webservices.service";
import { UtilsService } from 'src/app/services/utils/utils.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { Subscription } from 'rxjs';
import { BannerService } from 'src/app/services/banner/banner.service';
import { GameTileService } from 'src/app/services/game-tile/game-tile.service';


@Component({
  selector: 'game-details',
  templateUrl: './game-details.component.html',
  styleUrls: ['./game-details.component.scss'],
})

export class GameDetailsComponent implements OnInit, OnDestroy {

  @Input() gamedata: any

  private readonly notFound = 'N/A';
  private extraData: any;
  public additionalImages: string[] = [];
  public category: string;
  public customerId: any = null;
  public description: string;
  public imagePath: string;
  public gameName: string;
  public isAuthenticated: boolean = false;
  public isDemoEnabled: boolean = false;
  public isWeb = true
  public maxBet: string;
  public minBet: string;
  public provider: string;
  public wageringBonusContribution: string;
  public sessionToken: string = null;
  private subscr: Array<Subscription> = [];

  constructor(
    private bannerService: BannerService,
    private gameHubControllerService: GameHubControllerService,
    private gameTileService: GameTileService,
    private navigator: Navigator,
    private platform: Platform,
    private userSessionService: UserSessionService,
    private utils: UtilsService,
    private webservices: WebservicesService,
  ) {
  }

  ngOnInit() {
    this.getCustomer();
    this.initializeGameData();
    this.setPlatformType();
    this.setupAdditionalImages();
    this.initializeExtraLaunchData();
    this.userSessionService.getCustomerSubscription().then(subscription => this.subscribeToCustomer(subscription));
    this.updateAuthentication();
  }
  onCarouselSlideClick = (item: any) => this.bannerService.handleSelectedCampaign(item);
  ngOnDestroy(): void {
    this.subscr.forEach(s => s.unsubscribe());
  }

  private initializeGameData() {
    this.gameName = this.gamedata?.game_name ?? this.notFound;
    this.description = this.gamedata?.description ?? this.notFound;
    this.provider = this.gamedata?.display_name ?? this.notFound;
    this.category = this.gamedata?.super_type ?? this.notFound;
  }

  private async getCustomer() {
    try {
      const customerSubscription = await this.userSessionService.getCustomerSubscription();
      const customer: CustomerModel = await new Promise((resolve, reject) => {
        this.subscr.push(customerSubscription.subscribe({
          next: (customer: CustomerModel) => resolve(customer),
          error: (err: any) => reject(err)
        }));
      });

      this.customerId = customer?.customerId;
      this.fetchExtraData();
    } catch (error) {
      console.error('Error getting customer subscription:', error);
    }
  }


  private fetchExtraData() {
    const params = {
      customer_id: this.customerId ?? null,
      game_launcher_id: this.gamedata.id,
      session_token: this.userSessionService?.getSessionToken() ?? null
    };

    this.webservices.get('games/get-casino-data', params).subscribe({
      next: response => {
        if (response) {
          this.extraData = response.payload;
          this.wageringBonusContribution = this.extraData.wager_bonus_contribution || this.extraData.wager_bonus_contribution == 0 ? `${Number(this.extraData.wager_bonus_contribution) * 100}%` : this.notFound;
       }
      },
      error: error => {
        console.error('get-casino-data: error', error);
      },
    });
  }

  private setPlatformType() {
    this.isWeb = !this.platform.is('mobile');
  }

  private setupAdditionalImages() {
    const prePath = this.gameTileService.galleryImagePath;
    const { imagename2, imagename3, imagename4, imagename5 } = this.gamedata;

    if (imagename3) this.additionalImages.push(prePath + imagename3);
    if (imagename4) this.additionalImages.push(prePath + imagename4);
    if (imagename5) this.additionalImages.push(prePath + imagename5);

    if (this.additionalImages.length > 0) {
      this.additionalImages.unshift(prePath + imagename2);
    } else {
      this.imagePath = imagename2 ? prePath + imagename2 : this.utils.getCDNAsset('images/game_placeholder.jpg');
    }
  }

  private initializeExtraLaunchData() {
    const extraLaunchData = this.gamedata.extra_launch_data ? JSON.parse(this.gamedata.extra_launch_data) : null;
    this.minBet = extraLaunchData?.minBetDisplay ? `$${extraLaunchData.minBetDisplay}` : this.notFound;
    this.maxBet = extraLaunchData?.maxBetDisplay ? `$${extraLaunchData.maxBetDisplay}` : this.notFound;
  }

  private updateAuthentication() {
    this.isAuthenticated = this.userSessionService.isAuthenticated();
  }

  private subscribeToCustomer(subscription) {
    this.subscr.push(subscription.subscribe(() => {
      this.updateAuthentication();
      this.updateDemoMode();
    }));
  }

  private updateDemoMode() {
    const demoModeEnabled = false;
    const demoLoggedOutEnabled = false;

    if (!demoModeEnabled) {
      this.isDemoEnabled = false;
    } else if (!demoLoggedOutEnabled && !this.isAuthenticated) {
      this.isDemoEnabled = false;
    } else {
      this.isDemoEnabled = true;
    }
  }

  launchCasinoGame() {
    if (!this.isAuthenticated) {
      return this.openLoginModal(this.gamedata);
    }
    this.onClose();
    return this.gameHubControllerService.launchCasinoGame(this.gamedata);
  }

  launchDemoPlay() {
    if (this.isAuthenticated) {
      this.onClose();
      return this.gameHubControllerService.launchCasinoGameDemo(this.gamedata);
    }
    this.navigator.toAgeVerificationModal(this.gamedata);
  }


  private openLoginModal(gameData) {
    this.gameTileService.waitingGameData = gameData;
    return this.navigator.navigateTo('LoginComponent');
  }

  protected onClose(): any {
    this.gameTileService.waitingGameData = null;
    return this.navigator.dismissAll();
  }

}
